import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Menu = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="menu"
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        stroke="none"
        d="M2 5.25C2 4.55964 2.55964 4 3.25 4H22.75C23.4404 4 24 4.55964 24 5.25C24 5.94036 23.4404 6.5 22.75 6.5H3.25C2.55964 6.5 2 5.94036 2 5.25ZM2 12.25C2 11.5596 2.55964 11 3.25 11H17.25C17.9404 11 18.5 11.5596 18.5 12.25C18.5 12.9404 17.9404 13.5 17.25 13.5H3.25C2.55964 13.5 2 12.9404 2 12.25ZM3.25 18C2.55964 18 2 18.5596 2 19.25C2 19.9403 2.55964 20.5 3.25 20.5H22.75C23.4404 20.5 24 19.9403 24 19.25C24 18.5596 23.4404 18 22.75 18H3.25Z"
      />
    </svg>
  );
};
/* eslint-enable max-len */

Menu.defaultProps = {
  className: null,
};

Menu.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  stroke: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Menu;
